var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"#fff","d":"M487.536,120.445c-4.16-4.16-10.923-4.16-15.083,0L245.339,347.581L18.203,120.467c-4.16-4.16-10.923-4.16-15.083,0\n\t\t\tc-4.16,4.16-4.16,10.923,0,15.083l234.667,234.667c2.091,2.069,4.821,3.115,7.552,3.115s5.461-1.045,7.531-3.136l234.667-234.667\n\t\t\tC491.696,131.368,491.696,124.605,487.536,120.445z"}))));
}

ArrowDown.defaultProps = {"width":"25","height":"13.5","viewBox":"0 0 490.656 490.656","xmlSpace":"preserve"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
